export default "__VITE_ASSET__gDO424SY__"